import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import { ChatContext } from 'context/Context';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import { Nav } from 'react-bootstrap';
import LastMessage from './LastMessage';
import { useNavigate } from 'react-router-dom';
import { FaTrash } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { deleteConversation } from 'redux/chatSlice';

const ChatThread = ({ thread }) => {
  const [openModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const navigate = useNavigate();
  const { isSearchConversation } = useContext(ChatContext);
  const { client: user, lastMessage, id } = thread;

  const handleDeleteConversation = async ids => {
    await dispatch(deleteConversation(ids));
    setOpenModal(false);
    //await dispatch(getConversations(userLogged.id));
  };
  const handleAvatarUrl = () => {
    if (user.photo) {
      return user.photo.match(/http/)
        ? user.photo
        : `${process.env.REACT_APP_CLIENT}/uploads/clients/profile-pictures/${user.photo}`;
    }
  };

  return (
    //   Al hacer click en un chat, se ejecuta la función handleSelect del componente ChatTab
    <>
      <Nav.Link
        eventKey={id}
        className={classNames(`chat-contact hover-actions-trigger p-3`, {
          'unread-message': !thread.read_at,
          'read-message': thread.read_at
        })}
        onClick={() => {
          navigate(`?cid=${id}`);
        }}
      >
        <div className="hola">
          <Flex>
            <Avatar
              className={user.status}
              src={handleAvatarUrl()}
              name={`${user.firstName} ${user.lastName}`}
              size="xl"
            />

            <div
              className={classNames(
                'flex-1 chat-contact-body ms-2 d-lg-block opacity-lg-100 ms-lg-2',
                {
                  'opacity-md-0': !isSearchConversation,
                  'w-md-0': !isSearchConversation,
                  'ms-md-0': !isSearchConversation
                }
              )}
              style={{
                transition: 'all 0.3s ease-in'
              }}
            >
              <Flex justifyContent="between">
                <h6 className="mb-0 chat-contact-title">{`${user.firstName} ${user.lastName}`}</h6>

                <span className="message-time fs--2">
                  {' '}
                  {!!lastMessage &&
                    dayjs(lastMessage.created_at).format(
                      dayjs().isSame(lastMessage.created_at, 'day')
                        ? 'HH:mm'
                        : 'DD/MM/YYYY'
                    )}{' '}
                </span>
              </Flex>

              <div className="min-w-0">
                <div
                  className={classNames('chat-contact-content pe-3', {
                    'fw-normal': !!lastMessage?.read_at || !!lastMessage?.user
                  })}
                >
                  <LastMessage lastMessage={lastMessage} thread={thread} />
                  <div className="position-absolute bottom-0 end-0 hover-hide">
                    {!!lastMessage?.read_at && !!lastMessage?.user && (
                      <FontAwesomeIcon
                        icon="check-double"
                        transform="shrink-5 down-4"
                        className="text-primary"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <button
              className="btn btn-danger p-1"
              style={{ height: '60%', marginLeft: '.7em' }}
              onClick={handleOpenModal}
            >
              <FaTrash />
            </button>
          </Flex>

          <Modal
            centered
            show={openModal}
            styles={{
              modal: {
                position: 'relative'
              }
            }}
          >
            <div style={{ position: 'relative', padding: '20px' }}>
              <h4 className="mb-3">
                Usted esta a punto de Eliminar Esta conversacion.
              </h4>
              <h4 className="mb-3">¿Desea Proseguir?</h4>
              <div
                className="d-flex justify-center"
                style={{ alignItems: 'center', justifyContent: 'center' }}
              >
                <button
                  className="btn btn-success h-1"
                  style={{
                    fontSize: '16px',
                    height: '50%',
                    marginRight: '1rem'
                  }}
                  onClick={() => handleDeleteConversation(thread.id)}
                >
                  Confirmar
                </button>
                <button
                  onClick={() => setOpenModal(false)}
                  className="btn btn-danger ms-2"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </Nav.Link>
    </>
  );
};

ChatThread.propTypes = {
  thread: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
};

export default ChatThread;
